import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Permissions_RLP_Settings extends PureComponent {
  render() {
    return (
      <div className="row" id="permissions_rlp_settings">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Setting Record Level Permissions</h2>
              <p>
                Record level permissions are stored in a text array for each
                record. There are multiple ways to create a rlp text array. In
                user or group customisation you can override the model and
                either set a default or RLP in the drop down or you can use a
                model override if you have a more complex permission structure.
              </p>
              <p>
                Some modules give the user the option to select the RLP. This is
                useful in workflows where one team assigns a record to another
                team. Note that the user can change a RLP on a record that they
                have access to edit to a RLP setting that they do not have
                access to the record. This will return and access denied message
                when they next try to open the record.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Setting Record Level Permission Examples</h2>
            </section>
            <section>
              <h3>Example 1</h3>
              <p>
                This example will update the <strong>incident</strong> record
                with the ID of <strong>62587</strong> The record level
                commission groups of <strong>ICT</strong> and{" "}
                <strong>FACILITIES</strong>.
              </p>
              <p>
                Note you need to change your API URL and your Session ID. For
                more information look at API getting started.
              </p>
              <p>Patch REST:</p>
              <div className="darkCode">
                <div className="darkCode">
                  <div>
                    PATCH - https://uk1.api.nexoid.com/record/incident/62587
                  </div>
                  <div>
                    <br />
                  </div>
                  <div>&#123;</div>
                  <div className="i1">
                    <span className="jsonG">"session_id"</span>:{" "}
                    <span className="jsonY">
                      "251_p2w5u3hbz3ioys2ozosnzpgmmbtgtp64"
                    </span>
                    ,
                  </div>
                  <div className="i1">
                    <span className="jsonG">"record"</span>: &#123;
                  </div>
                  <div className="i2">
                    <span className="jsonG">"array_text_rlp"</span>: [
                    <span className="jsonY">"ICT"</span>,{" "}
                    <span className="jsonY">"FACILITIES"</span>]
                  </div>
                  <div className="i1">&#125;</div>
                  <div>&#125;</div>
                </div>
              </div>
            </section>
            <section>
              <h3>Example 2</h3>
              <p>
                This example shows you how to use the user or group overwrite
                model “create record default” function. This is how to set a
                user or group to automatically fill define data into a record on
                creation.
              </p>
              <p>
                When this user or group creates an <strong>incident</strong>{" "}
                object it will automatically have the RLP setting of{" "}
                <strong>ICT</strong>.
              </p>
              <p>
                To use this example paste the code in the model override section
                of customised on either a user or group.
              </p>
              <p>Permission:</p>
              <div className="darkCode">
                <div className="darkCode">
                  <div>&#123;</div>
                  <div className="i1">
                    <span className="jsonG">"data_objects"</span>: &#123;
                  </div>
                  <div className="i2">
                    <span className="jsonG">"incident"</span>: &#123;
                  </div>
                  <div className="i3">
                    <span className="jsonG">"default"</span>: &#123;
                  </div>
                  <div className="i4">
                    <span className="jsonG">"array_text_rlp"</span>: [
                    <span className="jsonY">"ICT"</span>]
                  </div>
                  <div className="i3">&#125;</div>
                  <div className="i2">&#125;</div>
                  <div className="i1">&#125;</div>
                  <div>&#125;</div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Permissions_RLP_Settings;



// WEBPACK FOOTER //
// ./src/components/knowlege/security/Permissions_RLP_Settings.js